import resolveSelectedRunHistoryDateFilter from '@/lib/automations/resolveSelectedRunHistoryDateFilter.js';
import { currentWorkflow } from './automationWorkflowSelectors.js';
import { query } from '@/redux/selectors/uiSelectors.js';
import { activeCompanyId } from '@/redux/selectors/userSelectors.js';

export const workflowRunSearchQuery = (state) => String(query(state, 'logSearch') || '').trim();

export const workflowRunSearchKey = (state) => JSON.stringify([activeCompanyId(state), currentWorkflow(state)?.workflowId, resolveSelectedRunHistoryDateFilter(query(state, 'range')), workflowRunSearchQuery(state)]);

export const workflowRunSearchSnapshot = (state) => (state.pieve.workflowRunSearch?.requestKey === workflowRunSearchKey(state) ? state.pieve.workflowRunSearch : null);
